import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class SupportViewGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean {
    const inSupportView = localStorage.getItem('supportViewMode') === 'true';
    const accountId = localStorage.getItem('supportAccountId');

    if (inSupportView && !!accountId) {
      return true;
    }

    this.router.navigate(['/support/advanced-search']);
    return false;
  }
}

